import React, { FC, useEffect } from 'react';
import { GeneralOverviewPageRenderedComponentProps } from '../../../../layout/general/SimpleGeneralPageWrapper';
import useTitleBarSelect from '../../../../../hooks/useTitleBarSelect';
import ExposureGraphics from './components/ExposureGraphics.component';
import EquityTable from './components/table/table.component';
import { useDispatch } from 'react-redux';
import { Select } from '../../../../../types/redux/pages/PagesStore';
import {
  addAdditionalTitleBarComponents,
  removeTitleBarComponent,
} from '../../../../../redux/pages/actions';
import {
  APPEND_NEW_SELECT_TO_TITLEBAR,
  REMOVE_SELECT_FROM_TITLEBAR,
} from '../../../../../types/redux/pages/pageTypes';
import { useMancoEquityPageModel } from '../../../../../api/rs-hg/manco';
import { QueryBoundary } from '../../../../utilityComponents/QueryBoundary';
import { EquityServerData } from './components/table/table.data';

const MancoEquity: FC<GeneralOverviewPageRenderedComponentProps> = ({
  positionDate,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const selectsToAdd: Select[] = [
      {
        titleBarTitle: 'Visualisation: ',
        titleBarKey: 'selectVisualisation',
        values: [
          {
            label: 'Position Table',
            value: 'table',
          },
          {
            label: 'Exposure Graphics',
            value: 'exposure',
          },
        ],
        displayOnOverviewPage: true,
        aValueIsAlwaysSelected: true,
        currentValue: 'table',
      },
    ];

    dispatch(
      addAdditionalTitleBarComponents(
        selectsToAdd,
        APPEND_NEW_SELECT_TO_TITLEBAR,
      ),
    );

    return () => {
      dispatch(
        removeTitleBarComponent(
          'selectVisualisation',
          REMOVE_SELECT_FROM_TITLEBAR,
        ),
      );
    };
  }, [dispatch]);

  const selectedPage = useTitleBarSelect('selectVisualisation');
  const SelectedComponent =
    selectedPage === 'exposure' ? ExposureGraphics : EquityTable;

  const equityQuery = useMancoEquityPageModel(positionDate);
  const equityData = (equityQuery.data?.data ?? null) as EquityServerData | null;

  return (
    <QueryBoundary<EquityServerData>
      isLoading={equityQuery.isLoading}
      isFetching={equityQuery.isFetching}
      isError={equityQuery.isError}
      error={equityQuery.error}
      data={equityData}
      loadingMessages={[
        'Loading Manco Equity Data...',
        'This may take a few moments...',
      ]}
      errorMessage="No In-Scope or Available Data"
      noDataMessage="No In-Scope or Available Data"
    >
      {(report) => (
        <SelectedComponent
          selectedEquityPage={selectedPage || 'table'}
          equityData={report}
          isFetching={equityQuery.isFetching}
        />
      )}
    </QueryBoundary>
  );
};

export default MancoEquity;
